var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { attrs: { title: _setup.props.agesLine.src } }, [
    _vm._v(
      "\n    " +
        _vm._s(_setup.props.agesLine.since) +
        " – " +
        _vm._s(_setup.till) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }